import { pushGtmEvent } from './gtmEvents'

/** Friendly copy for ?sso_error=… after Google sign-in (see backend GoogleAuthController). */
export var GOOGLE_SSO_ERROR_MESSAGES = {
  google_cancelled: 'Google sign-in was cancelled. You can try again or use your email.',
  google_unverified: "Your Google email isn't verified. Verify it with Google, or use your email instead.",
  google_mismatch: 'This email is linked to a different Google account. Log in with your password, or use the Google account you signed up with.',
  google_expired: 'Your Google sign-in expired. Please try again.',
  google_unavailable: "Google sign-in isn't available right now. Please use your email.",
  google_failed: 'Something went wrong with Google sign-in. Please try again or use your email.',
  account_locked: 'This account is temporarily locked after too many attempts. Try again later or reset your password.'
}

// One-shot params from earlier SSO round-trips; never send them back to Google as the return path.
var TRANSIENT_PARAMS = ['sso', 'sso_error', 'finish', 'handoff']

/**
 * Current route as a return path, keeping e.g. the Appstore amazon_callback_uri / amazon_state /
 * selling_partner_id so the existing handoff continues after Google.
 */
export function googleReturnPath (route) {
  var query = Object.assign({}, route.query)
  TRANSIENT_PARAMS.forEach(function (key) { delete query[key] })
  var search = Object.keys(query).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
  }).join('&')
  return route.path + (search ? '?' + search : '')
}

/** Full-page redirect to Google via the backend; waits for GTM so the sso_click hit isn't lost. */
export function startGoogleSignIn (intent, returnPath, source) {
  var url = '/api/auth/google/start?intent=' + encodeURIComponent(intent) +
    '&source=' + encodeURIComponent(source || '') +
    '&return=' + encodeURIComponent(returnPath)
  pushGtmEvent({ event: 'sso_click', provider: 'google' }, function () {
    window.location = url
  })
}



// WEBPACK FOOTER //
// ./src/utils/googleSignIn.js